import { toZonedTime, toDate } from 'date-fns-tz';

export default function getLastFriday() {
    const timeZone = 'Pacific/Auckland';
    const today = new Date();
    const zonedDate = toZonedTime(today, timeZone);
    let day = zonedDate.getDay();
    const lastFriday = toZonedTime(today, timeZone);
    lastFriday.setDate(zonedDate.getDate() - ((day + 2) % 7));
    if (day === 5) {
        lastFriday.setDate(zonedDate.getDate() - 7);
    }
    return lastFriday
}
